import { CustomerIssue } from "types/issue";

type Address = {
  address1?: string;
  address2?: string;
  city?: string;
  state_or_province?: string;
  postal_code?: string;
};

enum ReportingEnrollmentStatus {
  Pending = "pending",
  Approved = "approved",
  Rejected = "rejected",
  Finished = "finished",

  /**
   * @deprecated used to support some old logic on API.
   * Should not be possible anymore. Listed here only
   * for type fullness.
   */
  OptedOut = "opted_out",
  /**
   * @deprecated used to support some old logic on API.
   * Should not be possible anymore. Listed here only
   * for type fullness.
   */
  Errored = "errored", // Ignore. Legacy status
  /**
   * @deprecated used to support some old logic on API.
   * Should not be possible anymore. Listed here only
   * for type fullness.
   */
  Closed = "closed" // Ignore. Legacy status
}

export type EnrollmentCase = {
  address: null | Address;
  allow_landlord_contact: boolean;
  auto_renew: boolean;
  can_move_out: boolean;
  card: null | {
    display: {
      last4: string;
    };
  };
  checked_out_at: null | Date;
  credit_enrollment_approved: boolean;
  disable_ongoing_upsell: boolean;
  id: number;
  landlord_verification_status:
    | "landlord_verification_pending"
    | "landlord_verified"
    | "landlord_verification_failed";
  lease_end_date: string;
  lease_month_to_month: boolean;
  lease_start_date: null | string;
  lease_verification_status:
    | "lease_verification_pending"
    | "lease_verified"
    | "lease_verification_failed";
  legal_entity: null | {
    phone?: string;
    company_name?: string;
    contact_first_name?: string;
    contact_last_name?: string;
    email?: string;
  };
  monthly_rent_amount: {
    cents: number;
    currency: string;
  };
  monthly_rent_day_of_month: number;
  move_in_date: string;
  must_verify_identity: boolean;
  next_screen: string;
  portal_verification_status: string;
  prices: {
    past: {
      cents: number;
      currency: string;
    };
    ongoing: {
      cents: number;
      currency: string;
    };
    enrollment: {
      cents: number;
      currency: string;
    };
  };
  reporting_enrollment_approved: boolean;
  reporting_enrollment_closed: boolean;
  reporting_enrollment_rejected: boolean;
  reporting_enrollment_status: ReportingEnrollmentStatus;
  show_pending_status: boolean;
  status: string;
  subscribed_for_ongoing: boolean;
  subscribed_for_past: boolean;
  waitlisted_for_boom_split: boolean;
};

// TODO: auto generated code
export type Enrollment = {
  id: number;
  address: null | Address;
  portal_auth_credential: null | string;
  bank_account: null | {
    id: number;
    // ... TODO: see response
  };
  monthly_rent_amount: {
    cents: number;
    currency: string;
  };
  reporting_enrollment_status?:
    | "pending"
    | "approved"
    | "rejected"
    | "finished";
  issues?: CustomerIssue[];
  monthly_rent_day_of_month: number;
  move_in_date: null | string;
  lease_start_date: null | string;
  lease_end_date: null | string;
  lease_month_to_month: boolean;
  legal_entity: null | {
    phone?: string;
    company_name?: string;
    contact_first_name?: string;
    contact_last_name?: string;
    email?: string;
  };
  enrollment_case: EnrollmentCase;
  status: "started" | "ended" | "paused" | "cancelled";
  lease_verification_status:
    | "lease_verification_pending"
    | "lease_verified"
    | "lease_verification_rejected";
  landlord_verification_status:
    | "landlord_verification_pending"
    | "landlord_verified"
    | "landlord_verification_failed";
  portal_verification_status:
    | "portal_verification_pending"
    | "portal_verified"
    | "portal_verification_rejected";
  identity_verification_status:
    | "identity_verification_pending"
    | "identity_verified"
    | "identity_verification_rejected";
  next_screen: string;
  submitted: boolean;
  must_verify_identity: boolean;
  show_pending_status: boolean;
  subscribed_for_past: boolean;
  allow_landlord_contact: null | boolean;
  subscribed_for_ongoing: boolean;
  reporting_enrollment_approved: boolean;
  reporting_enrollment_closed: boolean;
  reporting_enrollment_rejected: boolean;
  reporting_account_created_at?: string;
  disable_ongoing_upsell: boolean;
  waitlisted_for_boom_split: boolean;
  credit_enrollment_approved: boolean;
  auto_renew: boolean;
  checked_out_at: null | Date;
  card: null | {
    display: {
      last4: string;
    };
  };
  can_move_out: null | boolean;
  prices: {
    past: {
      cents: number;
      currency: string;
    };
    ongoing: {
      cents: number;
      currency: string;
    };
    enrollment: {
      cents: number;
      currency: string;
    };
  };
};

export enum Views {
  INTRO = "intro",
  PLAID = "plaid",
  CONFIRM_PERSONAL_INFO = "confirm_personal_info",
  CONFIRM_LEASE_INFO = "confirm_lease_info",
  PROPERTY_MANAGER_DETAILS = "property_manager_details",
  CHECK_OUT = "check_out"
}

export enum IssueViews {
  LEASE_UPLOAD = "lease_upload"
}
